import { render } from "./kaihu.vue?vue&type=template&id=57a45f6c&scoped=true"
import script from "./kaihu.vue?vue&type=script&lang=js"
export * from "./kaihu.vue?vue&type=script&lang=js"

import "./kaihu.vue?vue&type=style&index=0&id=57a45f6c&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a45f6c"]])

export default __exports__